export type NotifySeverity = 'success' | 'danger' | 'warning' | 'info';

export type NotifyAction = {
  label: string;
  onPress: () => void;
};

export type NotifyOptions = {
  duration?: number;
  action?: NotifyAction | undefined;
};

export type Notifier = (
  message: string,
  severity: NotifySeverity,
  options: { duration: number; action?: NotifyAction | undefined },
) => void;

const DEFAULT_DURATION = 2500;

let notifier: Notifier | undefined;

export function registerNotifier(impl: Notifier): void {
  notifier = impl;
}

export function notify(
  message: string,
  severity: NotifySeverity = 'info',
  options: NotifyOptions = {},
): void {
  notifier?.(message, severity, {
    duration: options.duration ?? DEFAULT_DURATION,
    action: options.action,
  });
}
